import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/(fullscreen)')({
  component: RouteComponent,
  beforeLoad: ({ context, location }) => {
    // No pending state to wait out: the session is hydrated from storage when
    // the store module loads, before this ever runs.
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      })
    }
  },
})

function RouteComponent() {
  return <Outlet />
}
